import { NETWORK_UPDATE_STATE } from './types';
export const setNetworkState = (data) => ({
    type: NETWORK_UPDATE_STATE,
    payload: data,
});
export default { setNetworkState };
